<template>
  <v-sheet
    v-ripple
    @click="viewIncompleteStudents"
    rounded
    v-if="hasStudentPermission"
    class="pa-3 card ma-2 ma-md-5 text-center"
    :elevation="4"
  >
  <div class="snapbox">
    <div style="font-weight: bold; font-size: 14;">Students Incomplete</div>
    {{ incompleteStudentCount }} 
  </div>
    

    <v-dialog scrollable v-model="showDialog" max-width="350px">
      <v-card class="pa-2">
        <v-card-title class="justify-space-between">
          <div>Incomplete Students</div>
          <div>
            <v-btn @click="showDialog = null" icon
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <div class="my-2 text-center text-caption">
            Found {{ pagination.totalSize }}
            <span v-if="pagination.totalSize >= pagination.pageSize"
              >, showing {{ pagination.pageSize }} results</span
            >
            <span v-else>results</span>
          </div>
          <v-list shaped>
            <v-list-item-group v-model="selectedStudent" color="primary">
              <v-list-item
                @click="view(student)"
                v-for="student in studentList"
                :key="student.id"
              >
                <v-list-item-content>
                  <v-list-item-title
                    >{{ student.firstName }} {{ student.lastName }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ student.contactTypeName }} ({{ ageGender(student) }})
                    <span v-if="!student.active"
                      ><v-divider vertical />(Inactive)</span
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <a class="nostyle mt-2" @click="$router.push({ name: 'student' })"> View more... </a>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { Role } from "@/router/_helper";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      showDialog: false,
      incompleteStudentCount: 0,
      incompleteStudentList: [],
      pagination: {
        current: 1,
        pageSize: 20,
        totalSize: 100,
      },
      options: {
        sortBy: [],
        sortDesc: [],
      },
      studentList: [],
      activeOnly: true,
      selectedStudent: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "currentUser", "userRoles"]),
    hasStudentPermission() {
      return (
        this.userRoles.includes(Role.ComplianceStudent) ||
        this.userRoles.includes(Role.Admin)
      );
    },
  },
  mounted() {
    this.getIncompleteStudents();
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage",
    ]),
    ...mapActions("student", ["fetchStudents"]),
    getIncompleteStudents() {
      const params = {
        page: 0,
        size: 10,
        sort: "id,desc",
        activeOnly: true,
        allRequirementComplete: false,
      };

      this.fetchStudents(params).then((response) => {
        if (response) {
          this.incompleteStudentCount = response.totalElements;
          this.incompleteStudentList = response.content;
        }
      });
    },
    viewIncompleteStudents() {
      if (this.incompleteStudentCount > 0) {
        this.showDialog = true;
        this.getResources();
      }
    },
    getResources() {
      //default to sorting by ID desc if not defined
      const sortBy =
        this.options["sortBy"] && this.options["sortBy"].length > 0
          ? this.options.sortBy[0]
          : "id";
      const sortDesc =
        this.options["sortDesc"] && this.options["sortDesc"].length > 0
          ? this.options.sortDesc[0]
          : true;

      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
        activeOnly: this.activeOnly,
        allRequirementComplete: false,
      };

      this.fetchStudents(params)
        .then((response) => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.studentList = response.content;
          }
        })
        .catch((error) => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    view(student) {
      this.$router.push({ name: "studentView", params: { id: student.id } });
    },
    ageGender(student) {
      let info = "";
      if (student.dob) {
        const ageYears = moment().diff(student.dob, "years", false);
        const ageMonths = moment().diff(student.dob, "months", false) % 12;
        info += `${ageYears}y${ageMonths}m`;
      }
      if (student.gender) {
        if (info) {
          info += ` ${student.gender} `;
        } else {
          info = student.gender;
        }
      }
      return info;
    },
  },
};
</script>
<style scoped>
.card {
  cursor: pointer;
}
.nostyle {
  text-decoration: none;
}

.snapbox{
  display: block;
}

@media (max-width: 1400px) {
  .snapbox {
    font-size: 12px;
  }
}
</style>